import classes from '@/components/Form/Fields/FormText/FormText.module.scss';
import { RichText } from '@/components/richText/RichText';
import type { FormTextStoryblok } from '@/types/component-types-sb';
import classNames from 'classnames';
import { type FC } from 'react';

type IFormText = {
  blok: FormTextStoryblok;
};

const FormText: FC<IFormText> = ({ blok }) => {
  return (
    <div className={classNames(classes.formText, blok.variant && classes[blok.variant as string])}>
      {blok.label && blok.label}
      <RichText text={blok.text} />
    </div>
  );
};

export default FormText;
